import { emitUIEvent } from '@montugroup/data-collection';
import { Box, Stack, Typography } from '@mui/material';
import type { FC } from 'react';

interface DashboardCardProps {
  id: string;
  name: string;
  description?: string;
  onSelect: (id: string) => void;
}

export const DashboardCard: FC<DashboardCardProps> = ({ id, name, description, onSelect }) => {
  const handleClick = () => {
    emitUIEvent(
      {
        component_name: 'DashboardCard',
        event_name: 'onClick',
        id: 'reports-dashboard-card',
        value: `${name}|${id}`,
      },
      [],
    );

    onSelect(id);
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        py: { xs: 1, md: 2 },
        px: 2,
        boxShadow:
          '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)',
        borderRadius: 1,
        cursor: 'pointer',
        '&:hover': {
          bgcolor: 'action.hover',
        },
        '&:focus': {
          outline: '2px solid',
          outlineColor: 'primary.main',
          outlineOffset: 2,
        },
      }}
    >
      <Stack sx={{ py: 1, gap: 1 }}>
        <Typography component="h3" variant="subtitle2" sx={{ fontWeight: 600 }}>
          {name}
        </Typography>
        {description && (
          <Typography component="p" variant="body1" sx={{ color: 'text.secondary' }}>
            {description}
          </Typography>
        )}
      </Stack>
    </Box>
  );
};
